
export class MessageBase<T> {
    // tslint:disable-next-line:variable-name
    private _type: string;


    constructor(messageType: { new(...args: any[]): T }) {
        // define type
        this._type = (messageType as any).name;
    }

    get type(): string {
        return this._type;
    }
}
